import { useLayoutEffect, useRef} from "react";
import {get_build_info} from "@/services/common.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";

interface Data {
    date:string
    date_unix:string
    number:string
    version:string
}

const BuildVersionListener = () => {
    
    const effect_ran = useRef<boolean>(false)
    const interval = useRef<any>(null)
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    const seconds = debug === "true" ? 10 : 60
    
    const data_factory = (json:any):Data => {
        return {
            date: typeof json?.["date"] === "string" ? json?.["date"] : "",
            date_unix: typeof json?.["date_unix"] === "string" ? json?.["date_unix"] : "",
            number: typeof json?.["number"] === "string" ? json?.["number"] : "",
            version: typeof json?.["version"] === "string" ? json?.["version"] : "",
        }
    }
    
    const stopListener = () => {
        clearInterval(interval.current)
    }
    
    useLayoutEffect(() => {
        const listen = async () => {
            const req = await get_build_info()
            const data:Data = data_factory(req.response)
            
            const init_date = Number(import.meta.env.VITE_BUILD_DATE_UNIX)
            const update_date = Number(data.date_unix)
            
            if(debug === "true") {
                console.info("import.meta.env.VITE_BUILD_DATE_UNIX", import.meta.env.VITE_BUILD_DATE_UNIX)
                console.info("init_date", init_date)
                console.info("update_date", update_date)
            }



            if(init_date && update_date){
                if(update_date > init_date) {
                    stopListener()
                    eventEmitter.emit(CommonClass.ModalEvents.BuildVersionModalOpen, true)
                }
            }
        }
        
        if(!effect_ran.current) {
            if(import.meta.env.MODE !== "development") {
                interval.current = setInterval(() => {
                    listen()
                }, seconds * 1000)
            } else {
                listen()
            }
            
        }
        
        eventEmitter.on(CommonClass.CustomEvents.clear_build_interval, stopListener)
        
        return () => {
            eventEmitter.off(CommonClass.CustomEvents.clear_build_interval, stopListener)
            
            effect_ran.current = true
        }
        
    }, []);

    
    return (
        <></>
    )
}

export default BuildVersionListener